/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Disconnect_IntroInputs */



/**
* | output |
* | --- |
* | "Your calendar will stop syncing. Here's what happens:" |
*
* @param {Connections_Disconnect_IntroInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_disconnect_intro = /** @type {((inputs?: Connections_Disconnect_IntroInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Disconnect_IntroInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Je agenda stopt met synchroniseren. Dit is wat er gebeurt:")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre agenda ne se synchronise plus. Voici ce qui se passe :")
	return /** @type {LocalizedString} */ ("Your calendar will stop syncing. Here's what happens:")
});